import React, { useEffect } from "react";
//import ReactDOM from "react-dom/client";
import { Routes, Route, HashRouter, Navigate } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import "./App.scss";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Home from "./pages/Home";
import ThinClient from "./pages/ThinClient";
import Trial from "./pages/Trial";
import StdInstall from "./pages/stdInstall";
import Iot from "./components/PageNotFound";
import PageNotFound from "./components/PageNotFound";
import Confirmation from "./pages/Confirmation";
import common_en from "./i18n/common_en.json";
import common_fr from "./i18n/common_fr.json";
import common_de from "./i18n/common_de.json";
import common_it from "./i18n/common_it.json";
import common_es from "./i18n/common_es.json";
// import common_zhcn from "./i18n/common_zhcn.json";
import common_zhcn from "./i18n/common_zh-CN.json";
import common_ja from "./i18n/common_ja.json";
import CustomAlertService from "./services/CustomAlertService";
import Confirmationmsg from "./pages/Confirmationmsg";

i18next.init({
  interpolation: { escapeValue: false },  // React already does escaping
  lng: "en",                              // language to use
  resources: {
    en: {
      common: common_en               // "common" is our custom namespace
    },
    fr: {
      common: common_fr
    },

    de: {
      common: common_de
    },
    it: {
      common: common_it
    },
    es: {
      common: common_es
    },
    zhcn: {
      common: common_zhcn
    },
    ja: {
      common: common_ja
    },
  }
});
function App() {
  // i18next.changeLanguage("de")
  useEffect(()=>{
    window.alert = function(txt) {
        CustomAlertService.createCustomAlert(txt);
    }
  },[]);
  return (
    <>
      <I18nextProvider i18n={i18next}>
        <HashRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/thinclient" element={<ThinClient />} />
            <Route path="/iot" element={<Iot />} />
            <Route path="/trial/:id" element={<Trial />} />
            <Route path="/confirmation/:type" element={<Confirmation />} />
            <Route path="/confirmationmsg/:type" element={<Confirmationmsg />} />
            <Route path="/stdInstall/:id" element={<StdInstall />} />
            <Route path="notfound" element={<PageNotFound />} />
            <Route path="*" element={<Navigate to="/notfound" replace />} />
          </Routes>
        </HashRouter>
      </I18nextProvider>
    </>
  );
}

export default App;
